import capitalize from 'lodash/capitalize';

import { Button } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';
import { buildCheckoutUrl, type PaywallTrackingProps } from '@vimeo/picox';
import type { SubscriptionPlans } from '@vimeo/subscription-api-plans-data-hook';

interface PurchaseButtonProps {
  isTrial: boolean;
  planName?: string;
  paywallTracking: PaywallTrackingProps;
  subscriptionTier?: Partial<SubscriptionPlans['tier']>;
}

export function PurchaseButton({
  isTrial,
  planName,
  paywallTracking,
  subscriptionTier,
}: PurchaseButtonProps) {
  const handleClick = () => {
    if (typeof window === 'undefined' || !subscriptionTier) {
      return;
    }

    const checkoutPath = buildCheckoutUrl({
      ...paywallTracking,
      tier: subscriptionTier,
      isTrial,
    });

    window.location.assign(checkoutPath);
  };

  const resolvedPlanName = planName ?? (subscriptionTier ? capitalize(`${subscriptionTier}`) : '');

  const label = resolvedPlanName
    ? isTrial
      ? translate({
          singular: 'Try {PLAN_NAME} for free',
          replacements: { PLAN_NAME: resolvedPlanName },
        })
      : translate({
          singular: 'Join Vimeo {PLAN_NAME}',
          replacements: { PLAN_NAME: resolvedPlanName },
        })
    : isTrial
    ? translate('Try for free')
    : translate('Join Vimeo');

  return (
    <Button size="lg" variant="primary" width="100%" onClick={handleClick}>
      {label}
    </Button>
  );
}
